import $ from 'jquery';

const handleCompanyFieldChange = function handleProductOptionsChange() {
  let companyNameFields = $('input.company-name-field');
  companyNameFields.each((index, element) => {
    $(element).on('input', function (e) {
      const addressContainer = $(this).closest('div[id^=sylius]');
      const companyNameAditional = $(addressContainer).find('div.company-name-field-additional')
      const ico = $(companyNameAditional).find('input[name*="[ico]"]')
      const dic = $(companyNameAditional).find('input[name*="[dic]"]')

      if ($(this).val() !== "") {
        companyNameAditional.show();
      } else {
        companyNameAditional.hide();
        $(ico).val('');
        $(dic).val('');
      }
    }).trigger('input')
  })
};

$.fn.extend({
  addressCompany() {
    if ($('input.company-name-field').length > 0) {
      handleCompanyFieldChange();
    }
  },
});
